import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { Typography } from '@usepepper/sprout-kit-ui';
import { View } from 'react-native';

interface AccountDetailAccountNotesProps {
  notes: string;
}

export const AccountDetailAccountNotes: React.FC<
  AccountDetailAccountNotesProps
> = ({ notes }) => {
  const [styles] = useStyles();

  return (
    <View style={styles.container}>
      <Typography color="$textSecondary" numberOfLines={5} size="$sm">
        {notes}
      </Typography>
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  container: {
    backgroundColor: theme.sk.color.bg.highlight.warning,
    borderRadius: theme.sk.spacing.spaceSmall,
    paddingHorizontal: theme.sk.spacing.spaceSMedium,
    paddingVertical: theme.sk.spacing.spaceSmall,
  },
}));
